import React from "react";
import styled from "@emotion/styled";
import { Button } from "../Button";
import { ModalButtonProp, ModalType } from "./types";

interface ModalFooterProps {
  primaryButton?: ModalButtonProp;
  secondaryButton?: ModalButtonProp;
  leftLink?: {
    text: string;
    href?: string;
  };
  className?: string;
  type?: ModalType;
}

const ModalFooter = ({
  primaryButton,
  secondaryButton,
  leftLink,
  className,
  type = "info",
}: ModalFooterProps) => {
  const isContentOnly = !primaryButton;
  if (isContentOnly) {
    return (
      <ModalFooterContainer
        className={className ?? ""}
        data-testid="modal-footer"
        contentOnly
      />
    );
  }

  return (
    <ModalFooterContainer
      className={className ?? ""}
      data-testid="modal-footer"
    >
      {leftLink && <LeftLink href={leftLink.href}>{leftLink.text}</LeftLink>}
      <ButtonsContainer type={type}>
        {secondaryButton && (
          <Button
            data-testid={secondaryButton.testId || "modal-secondary-button"}
            onClick={secondaryButton.onClick}
            disabled={secondaryButton.disabled}
            color="secondary"
          >
            {secondaryButton.text}
          </Button>
        )}
        {primaryButton && (
          <Button
            data-testid={primaryButton.testId || "modal-primary-button"}
            onClick={primaryButton.onClick}
            disabled={primaryButton.disabled}
            className={type}
          >
            {primaryButton.text}
          </Button>
        )}
      </ButtonsContainer>
    </ModalFooterContainer>
  );
};

const ModalFooterContainer = styled.div<{ contentOnly?: boolean }>`
  display: flex;
  padding: 40px;
  padding-top: ${(props) => (props.contentOnly ? 0 : 32)}px;
  border-radius: 0px 0px 7px 7px;
  background-color: var(--white);
  align-items: center;
  justify-content: space-between;
`;

const ButtonsContainer = styled.div<{ type: ModalType }>`
  display: flex;
  margin-left: auto;
  margin-right: auto;
  flex-direction: column;
  gap: 12px;
  & button {
    min-width: 70vw;
  }
  @media (min-width: 768px) {
    flex-direction: row;
    margin-right: inherit;
    gap: 24px;
    & button {
      min-width: 228px;
      max-width: 268px;
    }
  }
`;

const LeftLink = styled.a`
  color: var(--brand-hero-blue);
  text-decoration: underline;
  font-size: var(--font-size-1);
  font-weight: 400;
`;

export { ModalFooter };
